import { render, staticRenderFns } from "./expense-card-title.vue?vue&type=template&id=689ee9ca&"
import script from "./expense-card-title.vue?vue&type=script&lang=js&"
export * from "./expense-card-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports